import {
    apiRequest,
    positionBknList,
    positionBknInactive,
    positionBknActive
} from "../../../../../services/adapters/master/positionBknService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", positionBknList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", positionBknInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", positionBknActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository